import { render } from "./Divider.vue?vue&type=template&id=2d9878f7&scoped=true"
const script = {}

import "./Divider.vue?vue&type=style&index=0&id=2d9878f7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9878f7"]])

export default __exports__